export class FullscreenDialog {
  Titel: string;
  Text: string;
}
